import React from "react"
import subhero from "./subhero.module.scss"
import Subwaves from "../images/subwaves.svg"

export default function Subhero({ children }) {
  return (
    <div className={subhero.section}>
      <div className={subhero.wrapper}>{children}</div>
      <img src={Subwaves} alt=""></img>
    </div>
  )
}
